

import React, {useEffect, useState} from 'react';

import {COMMENT, ICommentItem} from 'fetch/works';

import IfRender from 'components/IfRender';
import {showModal} from 'components/Modal';

import Item from '../Item';
import ReplayList from '../ReplayList';

import s from './index.module.scss';

interface Props {
  comment: ICommentItem;
  onDelete: (id: number) => void;
}
  
const CommentItem: React.FC<Props> = ({
  comment,
  onDelete
}) => {

  const [showReplay, setShowReplay] = useState(false);
  const [data, setData] = useState({
    ...comment,
    liked: comment.hasPraised
  });

  useEffect(() => {
    setShowReplay(false);
  }, [comment])

  const onLicked = (commentId: number, liked: boolean) => {
    const fetchFn = liked ? COMMENT.unlike : COMMENT.like;
    const num = liked ? -1 : 1;
    fetchFn(commentId).then(() => {
      setData(pre => ({
        ...pre,
        liked: !pre.liked,
        praiseNum: pre.praiseNum+num
      }))
    }).catch((err) => {
      console.log('onLicked', err)
    })
  }

  const handleOnDelete = (commentId: number) => {
    showModal(
      '删除评论',
      '确定要删除吗？ 评论下的回复也会被一起删除～',
      '删除',
      'red'
    ).then((val: boolean) => {
      if(!val) return;
      COMMENT.del(commentId).then(() => {
        onDelete(commentId)
      }).catch(err => {
        console.log('err -->', err)
      })
    })
  }
  
  const handleCommentNumChange = (num: number) => {
    setData(pre => ({
      ...pre,
      replyNum: num
    }))
  }

  return (
    <div className={`${s.commentItem} ${showReplay && s.showReplay}`}>
      <Item 
        data={data} 
        onComment={() => setShowReplay(c => !c)}
        onLicked={(liked) => onLicked(comment.id, !!liked)}
        onDelete={() => handleOnDelete(comment.id)}
        showReplay={showReplay}
      />
      {/* 评论的回复列表 */}
      <IfRender show={showReplay}>
        <ReplayList 
          commentId={comment.id} 
          onCommentNumChange={handleCommentNumChange}
        />
      </IfRender>
    </div>
)
}
export default CommentItem;